import Styled from 'vue3-styled-components';

const CascaderStyle = Styled.div`
    margin: 20px 0;
    .ant-input{
        padding: 5.5px 20px;
    }
    .anticon svg{
        width: 10px;
        height: 8.5px;
    }
`;

export { CascaderStyle };
